import React from "react";
import "../css/Services.css";

const Services = () => {
  return (
    <div className="services5">

      {/* ============================================
          HERO — NATURAL SAND CURVE
      ============================================= */}
      <section className="srv5-hero">
        <h1>Our Natural Approach</h1>
        <p>Training shaped by earth, breath, balance, and mindful strength.</p>

        <div className="srv5-curve"></div>
      </section>



      {/* ============================================
          EARTH SERVICE ROW — 4 NATURAL PILLARS
      ============================================= */}
      <section className="srv5-pillars">

        <div className="srv5-item">
          <img src="https://images.pexels.com/photos/1552249/pexels-photo-1552249.jpeg" alt="" />
          <h3>Grounded Strength</h3>
          <p>Build steady, controlled power rooted in aligned form.</p>
        </div>

        <div className="srv5-item">
          <img src="https://images.pexels.com/photos/3823039/pexels-photo-3823039.jpeg" alt="" />
          <h3>Mobility Flow</h3>
          <p>Breath-led stretching that unlocks natural movement patterns.</p>
        </div>

        <div className="srv5-item">
          <img src="https://images.pexels.com/photos/6740337/pexels-photo-6740337.jpeg" alt="" />
          <h3>1:1 Coaching</h3>
          <p>Personalized sessions tailored around pace, intention, and body rhythm.</p>
        </div>

        <div className="srv5-item">
          <img src="https://images.pexels.com/photos/3769021/pexels-photo-3769021.jpeg" alt="" />
          <h3>Mindful Conditioning</h3>
          <p>Low-impact cycles to improve endurance without overstress.</p>
        </div>

      </section>



      {/* ============================================
          ORGANIC SPLIT PANEL — EARTH & GREEN
      ============================================= */}
      <section className="srv5-split">

        <div className="split-left">
          <h2>Move With Presence</h2>
          <p>
            Every training session follows a simple idea —  
            <strong>move like nature.</strong>  
            Slow when needed, powerful when ready, always with awareness.
          </p>
        </div>

        <div className="split-right">
          <img 
            src="https://images.pexels.com/photos/3823063/pexels-photo-3823063.jpeg"
            alt="split"
          />
        </div>

      </section>



      {/* ============================================
          EARTH SERVICE GRID — ORGANIC BEIGE BLOCKS
      ============================================= */}
      <section className="srv5-grid">

        <div className="g-block">
          <h3>Breath Integration</h3>
          <p>Your inhale & exhale guide tempo, control, and posture.</p>
        </div>

        <div className="g-block">
          <h3>Strength Foundations</h3>
          <p>Develop functional power that supports everyday movement.</p>
        </div>

        <div className="g-block">
          <h3>Holistic Programs</h3>
          <p>Well-rounded routines made for long-term sustainable growth.</p>
        </div>

        <div className="g-block">
          <h3>Recovery Guidance</h3>
          <p>Reduce tension, restore alignment, and improve comfort.</p>
        </div>

      </section>



      {/* ============================================
          CALM EARTH CLOSER
      ============================================= */}
      <section className="srv5-end">
        <h2>Training That Feels Natural</h2>
        <p>We help you grow without the rush — grounded, centered, and steady.</p>
      </section>

    </div>
  );
};

export default Services;
